var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSlack = function SvgSlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("title", null, "slack"), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.5,8.75a1.5,1.5,0,0,1-3,0V2.25a1.5,1.5,0,0,1,3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,4.25H9.25A1.75,1.75,0,1,1,11,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.75,7.5a1.5,1.5,0,0,1,0,3H2.25a1.5,1.5,0,0,1,0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.25,13v1.75A1.75,1.75,0,1,1,2.5,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.5,15.25a1.5,1.5,0,0,1,3,0v6.5a1.5,1.5,0,0,1-3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,19.75h1.75A1.75,1.75,0,1,1,13,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.25,16.5a1.5,1.5,0,0,1,0-3h6.5a1.5,1.5,0,0,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.75,11V9.25A1.75,1.75,0,1,1,21.5,11Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "slack.581ff29d751594e9f2e64219452ef3bb.svg";